import { gql } from '@urql/core';

export const MY_ORGANIZATION_QUERY = gql`
  query MyOrganization {
    myOrganization {
      id
      name
      about
      tinNo
      serviceIndustry
    }
  }
`;

export const CREATE_ORGANIZATION_MUTATION = gql`
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      id
      name
      about
      tinNo
      serviceIndustry
    }
  }
`;

export const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation UpdateOrganization($id: String!, $input: UpdateOrganizationInput!) {
    updateOrganization(id: $id, input: $input) {
      id
      name
      about
      tinNo
      serviceIndustry
    }
  }
`;